import { Component, Input, OnInit, inject } from '@angular/core';
import {
  IActivo,
  IFilter,
  IPopulate,
  IQueryParam,
  ITrackeo,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { IColumnas } from '../../../../../../auxiliares/tabla/tabla.component';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../../../auxiliares/dialog/dialog.service';
import { TrackeosService } from '../../../../../../auxiliares/servicios/http/trackeos.service';
import { Lista2Service } from '../../../../../../auxiliares/servicios/lista2.service';

interface ITrackeoTabla extends ITrackeo {
  index?: number;
}

@Component({
  selector: 'app-listado-trackeos',
  templateUrl: './listado-trackeos.component.html',
  styleUrl: './listado-trackeos.component.scss',
  standalone: false,
})
export class ListadoTrackeosComponent implements OnInit {
  helper = inject(HelperService);
  private lista2 = inject(Lista2Service);
  private dialogService = inject(DialogService);
  private service = inject(TrackeosService);

  @Input() vehiculo?: IActivo;

  //// Tabla nueva
  public name = 'ListadoTrackeosComponent';
  public trackeos?: ITrackeoTabla[];
  public trackeos$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<ITrackeoTabla>[];

  public filter: IFilter<ITrackeo> = {
    // idRecorrido: this.vehiculo?.idRecorrido,
  };
  public populate: IPopulate[] = [
    {
      path: 'recorrido',
      select: 'paradas.nombre paradas._id nombre',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: '-fecha',
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
  };

  private populateTrackeos() {
    if (!this.trackeos) return;

    for (const t of this.trackeos) {
      const recorrido = t?.recorrido;
      if (!recorrido) continue;
      const paradas = recorrido.paradas;
      if (!paradas) continue;
      t.parada = paradas.find((p) => p._id === t.idParada);
      const index = paradas.findIndex((p) => p._id === t.idParada);
      t.index = index + 1;
    }
    // for (const t of this.trackeos) {
    //   t.proximaParada = recorrido.paradas?.find(
    //     (p) => p._id === t.idProximaParada,
    //   );
    // }
  }

  public async listar(): Promise<void> {
    if (!this.vehiculo?._id) return;
    const filter: IFilter<ITrackeo> = JSON.parse(this.query.filter);
    filter.idActivo = this.vehiculo._id;
    // filter['idRecorrido'] = this.vehiculo.idRecorrido;
    this.query.filter = JSON.stringify(filter);
    this.trackeos$?.unsubscribe();
    this.trackeos$ = this.lista2.trackeos(this.query, 30).subscribe((data) => {
      this.totalCount = data.totalCount;
      this.trackeos = data.datos;
      this.populateTrackeos();
    });
  }

  public async eliminar(trackeo: ITrackeo) {
    const res = await this.dialogService.confirm(
      'Eliminar trackeo',
      `¿Querés eliminar el trackeo?`,
    );
    if (!res) return;
    try {
      await this.service.delete(trackeo._id!);
      this.helper.notifSuccess('Trackeo eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    this.columnas = [
      {
        header: {
          label: 'Fecha de creación',
        },
        row: {
          fecha: (dato) => dato.fecha,
          hace: true,
          noData: 'Sin fecha',
        },
      },
      {
        header: {
          label: 'Recorrido',
        },
        row: {
          // field: 'index',`
          parse(dato) {
            return dato.recorrido?.nombre;
          },
          noData: 'Sin recorrido',
        },
      },
      {
        header: {
          label: '#',
        },
        row: {
          // field: 'index',`
          // Número de la parada sobre el total del recorrido
          parse(dato) {
            const total = dato.recorrido?.paradas?.length;
            return dato.index && total ? `${dato.index} / ${total}` : undefined;
          },
          noData: 'Sin parada',
        },
      },
      // {
      //   header: {
      //     label: 'Total Paradas',
      //   },
      //   row: {
      //     parse(dato) {
      //       return dato.recorrido?.paradas?.length;
      //     },
      //   },
      // },
      {
        header: {
          label: 'Parada',
        },
        row: {
          parse(dato) {
            return dato.parada?.nombre;
          },
          noData: 'Sin parada',
        },
      },
      {
        header: {
          label: 'Acciones',
        },
        row: {
          acciones: [
            {
              tipo: 'material',
              color: 'warn',
              icon: 'delete',
              tooltip: 'Eliminar',
              click: (dato) => this.eliminar(dato),
            },
          ],
        },
      },
    ];
  }

  async ngOnInit() {
    this.setColumnas();
    await this.listar();
  }
}
